import script from "./PaymentReceipt.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentReceipt.vue?vue&type=script&setup=true&lang=js"

import "./PaymentReceipt.vue?vue&type=style&index=0&id=6bf8db20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bf8db20"]])

export default __exports__